import { render, staticRenderFns } from "./NoshiSvg.vue?vue&type=template&id=795e7736&"
import script from "./NoshiSvg.vue?vue&type=script&lang=js&"
export * from "./NoshiSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports